import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { lighten } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { Button, Row, Col, Form } from "react-bootstrap";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import "../index.css";
import AADService from "../funcionesAuth.js";
import CheckRole from "../CheckRole";
import { DecryptData } from "../DatosEncriptados/EncryptedFunctions";
import { FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
import XLSX from "xlsx";

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  {
    id: "idPlanAccion",
    numeric: false,
    disablePadding: true,
    label: "Id Plan Acción",
  },
  {
    id: "nombre",
    numeric: false,
    disablePadding: false,
    label: "Nombre",
  },
  {
    id: "estado",
    numeric: false,
    disablePadding: false,
    label: "Estado",
  },
  {
    id: "responsablepa",
    numeric: false,
    disablePadding: false,
    label: "ResponsablePA",
  },
  {
    id: "analistaRiesgo",
    numeric: false,
    disablePadding: false,
    label: "Responsable",
  },
  {
    id: "fechaCompromisoActual",
    numeric: false,
    disablePadding: false,
    label: "Fecha Compromiso Actual",
  },
  {
    id: "ultimoSeguimiento",
    numeric: false,
    disablePadding: false,
    label: "Ultimo Seguimiento",
  },
  {
    id: "porcentajeAvance",
    numeric: false,
    disablePadding: false,
    label: "Porcentaje(%) Avance",
  },
  {
    id: "comentarios",
    numeric: false,
    disablePadding: false,
    label: "Comentarios",
  },
];

/*Encabezado de tabla*/
function EnhancedTableHead(props) {
  const { classes, order, orderBy, numSelected, rowCount, onRequestSort } =
    props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  return (
    <TableHead>
      <TableRow>
        <TableCell
          padding="checkbox"
          style={{ backgroundColor: "#2c2a29", color: "#ffffff" }}
        ></TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "default"}
            sortDirection={orderBy === headCell.id ? order : false}
            style={{ backgroundColor: "#2c2a29", color: "#ffffff" }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
              className="texto"
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    //paddingLeft: theme.spacing(2),
    //paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.mode === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: "1 1 100%",
  },
}));

/*Número de tablas seleccionadas y eliminar (parte de arriba de la tabla)*/
const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const { numSelected } = props;
  return <Toolbar></Toolbar>;
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};
const useStyles = makeStyles((theme) => ({
  container: {
    maxHeight: "55vh",
    minHeight: "55vh",
  },
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    //marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
}));
/*Mapeado de la tabla completa */
export default function EnhancedTable({ params }) {
  const classes = useStyles();
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("name");
  const [selected, setSelected] = React.useState([]);
  const [selectedTipo, setSelectedTipo] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [queryText, setqueryText] = React.useState("");
  const [planaccion, setPlanAccion] = React.useState([]);
  const [ButtonEdit, SetButtonEdit] = React.useState(false);
  const [nameCompa, setNameCompa] = React.useState("");
  const [opcionesGenerales, setOpcionesGenerales] = React.useState([]);
  const [datosOriginales, setDatosOriginales] = useState([]);
  const [datosFiltrados, setDatosFiltrados] = useState([]);
  const [filtroTipo, setFiltroTipo] = useState("Todos");
  const [datosInforme, setDatosInforme] = useState([]);

  const AzureADService = new AADService();
  const token = AzureADService.getToken();
  const check = new CheckRole("/NewPlanAccion");
  const DescargaButtonStyle = {
    backgroundColor: "#9063CD",
    color: "white",
    border: "none",
    borderRadius: "8px",
    padding: "8px 16px",
    fontSize: "1rem",
    fontWeight: "600",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    transition: "all 0.3s ease",
    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
  };
  const DownloadIcon = () => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      {/* Flecha de descarga */}
      <line x1="12" y1="5" x2="12" y2="15" />
      <polyline points="8 11 12 15 16 11" />

      {/* Barra inferior */}
      <rect x="5" y="17" width="14" height="2" rx="1" />
    </svg>
  );
  useEffect(() => {
    const fetchdata_PA = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL + "evaluacion/NewplandeAccion/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      if (result.status == 200) {
        let data = await result.json();

        setDatosOriginales(data);
      } else {
        setDatosOriginales([]);
      }
    };

    const obtenerCompañias = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL + "general/compania/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      let datCompania = await result.json();
      setNameCompa(datCompania);
    };
    const fetchUsuario = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL +
          "usuarios/menu/" +
          localStorage.getItem("usuario") +
          "/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      const encryptedUser = await result.json();
      const decryptedUser = DecryptData(encryptedUser);
      let usuario = JSON.parse(decryptedUser);
      let opciones = [];
      let permisos = [];
      for (let i = 0; i < usuario.length; i++) {
        permisos = usuario[i].permisos.split(";");
        opciones.push({ opcion: usuario[i].url_opcion, permisos: permisos });
      }
      setOpcionesGenerales(opciones);
      var validity = check.checkPermits(opciones, "GET");
      if (validity) {
        fetchdata_PA();
        obtenerCompañias();
      }
    };
    fetchUsuario();
  }, []);

  useEffect(() => {
    const nuevosDatos =
      filtroTipo === "Todos"
        ? datosOriginales
        : datosOriginales.filter((item) => item.tipo === filtroTipo);
    setDatosFiltrados(nuevosDatos);
    setPage(0);
    setSelected([]);
  }, [filtroTipo, datosOriginales]);

  function bCompania(id) {
    for (const clave in nameCompa) {
      if (id == nameCompa[clave]["idcompania"]) {
        return nameCompa[clave]["compania"];
      }
    }
    return "No Existe";
  }
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleClick = (event, id, tipo) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];
    let newSelectedtipo = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat([], id);
      newSelectedtipo = newSelectedtipo.concat([], tipo);
      SetButtonEdit(true);
    } else {
      SetButtonEdit(false);
    }
    setSelected(newSelected);
    setSelectedTipo(newSelectedtipo);
  };
  const editar = (event) => {
    localStorage.setItem("idplanaccion", selected);
    localStorage.setItem("tipoplanaccion", selectedTipo);
  };
  function add_pa() {
    localStorage.setItem("idplanaccion", 0);
  }
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };
  const isSelected = (id) => selected.indexOf(id) !== -1;
  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, planaccion.length - page * rowsPerPage);
  const fetchdataInformePAS = async () => {
    const result_pas = await fetch(
      process.env.REACT_APP_API_URL +
      "descarga/plandeaccion/1/",
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          //Authorization: "Bearer " + token,
        },
      }
    );
    if (result_pas.status >= 200 && result_pas.status <= 300) {
      let data = await result_pas.json();
      datosInforme['planesaccion'] = data
    } else if (result_pas.status >= 400 && result_pas.status <= 500) {
      datosInforme['planesaccion'] = []
    }
    const result_pasxr = await fetch(
      process.env.REACT_APP_API_URL +
      "descarga/porriesgo/" +
      localStorage.getItem("idcompania") +
      "/1/",
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          //Authorization: "Bearer " + token,
        },
      }
    );
    if (result_pasxr.status >= 200 && result_pasxr.status <= 300) {
      let data = await result_pasxr.json();
      datosInforme['paxriesgo'] = data
    } else if (result_pasxr.status >= 400 && result_pasxr.status <= 500) {
      datosInforme['paxriesgo'] = []
    }
    const result_segxpas = await fetch(
      process.env.REACT_APP_API_URL +
      "descarga/seguimientoxpa/1/",
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          //Authorization: "Bearer " + token,
        },
      }
    );
    if (result_segxpas.status >= 200 && result_segxpas.status <= 300) {
      let data = await result_segxpas.json();
      datosInforme['seguimientos'] = data
    } else if (result_segxpas.status >= 400 && result_segxpas.status <= 500) {
      datosInforme['seguimientos'] = []
    }
    return datosInforme
  };
  const handleOnExport = (data) => {
    const newBook = XLSX.utils.book_new();

    const sheet1 = XLSX.utils.json_to_sheet(data["planesaccion"] || []);
    const sheet2 = XLSX.utils.json_to_sheet(data['paxriesgo'] || []);
    const sheet3 = XLSX.utils.json_to_sheet(data['seguimientos'] || []);

    const date = new Date();
    const formattedDate =
      String(date.getDate()).padStart(2, "0") +
      "_" +
      String(date.getMonth() + 1).padStart(2, "0") +
      "_" +
      date.getFullYear();

    XLSX.utils.book_append_sheet(newBook, sheet1, "PlanesDeAccion");
    XLSX.utils.book_append_sheet(newBook, sheet2, "PAs por Riesgos");
    XLSX.utils.book_append_sheet(newBook, sheet3, "Seguimientos por PA");
    XLSX.writeFile(newBook, "InformePAS_" + formattedDate + ".xlsx");
  };
  const handleExportClick = async () => {
    try {
      await new Promise((resolve) => setTimeout(resolve, 3000));
      const data = await fetchdataInformePAS();
      if (data) {
        handleOnExport(data);
      } else {
      }
    } catch (error) {
    }
  };
  return (
    <div className={classes.root}>
      <Row>
        <Col>
          <h2 className="titulo">Planes de Acción</h2>
        </Col>
        <Col style={{ paddingTop: "0.3%" }} sm={3} xs={6}>
          <Link to="NewEditarPlanAccion">
            {check.checkPermits(opcionesGenerales, "PUT") ? (
              <Button
                variant="warning"
                className="botonGeneral"
                style={{ display: ButtonEdit ? "inline" : "none" }}
                onClick={(event) => editar(event)}
              >
                {" "}
                Editar{" "}
              </Button>
            ) : (
              ""
            )}
          </Link>
        </Col>
      </Row>
      <Row style={{ marginTop: "1%", marginBottom: "0.5%" }}>
        <Col sm={3} xs={12}>
          <Form className="buscar">
            <Form.Control
              className="text-center "
              type="text"
              placeholder="Buscar"
              onChange={(e) => setqueryText(e.target.value)}
              style={{ align: "center" }}
            />
          </Form>
        </Col>
        <Col style={{ paddingTop: "0.3%" }} sm={3} xs={6}>
          <FormControl style={{ marginBottom: 20, minWidth: 200 }}>
            <InputLabel>Tipo Plan de Acción</InputLabel>
            <Select
              value={filtroTipo}
              onChange={(e) => setFiltroTipo(e.target.value)}
            >
              <MenuItem value="Todos">Todos</MenuItem>
              <MenuItem value="acis">Activos de Información</MenuItem>
              <MenuItem value="riesgos_new">Riesgos</MenuItem>
              <MenuItem value="riesgos_old">Riesgos (Ant)</MenuItem>
              <MenuItem value="lineasbase">Lineas Base</MenuItem>
            </Select>
          </FormControl>
        </Col>
        <Col style={{ paddingTop: "0.3%" }} sm={3} xs={6}>
          <Link to="NewNuevoPlanAccion">
            {check.checkPermits(opcionesGenerales, "POST") ? (
              <Button className="botonPositivo" onClick={() => add_pa()}>
                {" "}
                Nuevo{" "}
              </Button>
            ) : (
              ""
            )}
          </Link>
        </Col>
        <Col style={{ paddingTop: "0.3%" }} sm={3} xs={6}>
          <button
            style={{
              ...DescargaButtonStyle,
              marginLeft: "10px", // opcional para separación
            }}
            onClick={handleExportClick}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#7A4FB8"; // tono más oscuro
              e.target.style.transform = "scale(1.05)"; // efecto de agrandar
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "#9063CD"; // vuelve al original
              e.target.style.transform = "scale(1)"; // tamaño normal
            }}
          >
            <DownloadIcon />
            Descargar Planes de Acción
          </button>
        </Col>
      </Row>
      <Paper className={classes.paper}>
        {/* <EnhancedTableToolbar numSelected={selected.length} />*/}
        <TableContainer className={classes.container}>
          <Table
            stickyHeader
            className={classes.table}
            aria-labelledby="tableTitle"
            size={dense ? "small" : "medium"}
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              classes={classes}
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              rowCount={datosFiltrados.length}
            />
            <TableBody>
              {stableSort(datosFiltrados, getComparator(order, orderBy))
                .filter(
                  (row) =>
                    row.nombre?.toLowerCase().includes(queryText) ||
                    String(row.idplanaccion)?.toLowerCase().includes(queryText)
                )
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const isItemSelected = isSelected(row.idplanaccion);
                  const labelId = `enhanced-table-checkbox-${index}`;
                  return (
                    <TableRow
                      onClick={(event) =>
                        handleClick(event, row.idplanaccion, row.tipo)
                      }
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row.idplanaccion}
                      selected={isItemSelected}
                    >
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={isItemSelected}
                          inputProps={{ "aria-labelledby": labelId }}
                        />
                      </TableCell>
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                        padding="none"
                      >
                        {row.idplanaccion}
                      </TableCell>
                      <TableCell align="left">{row.nombre}</TableCell>
                      <TableCell align="left">{row.estadopa}</TableCell>
                      <TableCell align="left">{row.responsablepa}</TableCell>
                      <TableCell align="left">{row.analistariesgos}</TableCell>
                      <TableCell align="left">
                        {row.fechacompromisoactual}
                      </TableCell>{" "}
                      {/* Esta era la que faltaba */}
                      <TableCell align="left">{row.fechaseguimiento}</TableCell>
                      <TableCell align="left">
                        {parseFloat(row.porcentajeavance * 100).toFixed(2)}
                      </TableCell>
                      <TableCell align="left">
                        {row.descripcionseguimiento}
                      </TableCell>
                    </TableRow>
                  );
                })}
              {emptyRows > 0 && (
                <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <Row>
          <Col sm={4} xs={4}>
            <FormControlLabel
              style={{ paddingLeft: "10px" }}
              control={<Switch />}
              label="Mostrar Elementos Inactivos"
            />
          </Col>
          <Col xs={8}>
            {" "}
            <TablePagination
              rowsPerPageOptions={[10, 20, 30]}
              component="div"
              count={datosFiltrados.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              labelRowsPerPage={"Filas por página"}
            />
          </Col>
        </Row>
      </Paper>
    </div>
  );
}
